import html2pdf from "html2pdf.js";
export const postDownload = (title, element) => {
  const options = {
    margin: 0.75,
    filename: title,
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: { scale: 2, useCORS: true }, // scale 2 ensures crisp text zoom
    jsPDF: {
      unit: "in",
      format: "letter",
      orientation: "portrait",
    },
    pagebreak: {
      mode: ["css", "legacy"],
      // css: listens strictly to your break-inside / break-before rules
    },
  };
  html2pdf().set(options).from(element).save();
};
